import React from 'react';
import * as Bixby from '$/core';
import ClientHelpCenterBase from '../help-center-base';

const ClientUserGuides: React.FC = () => {
  return <ClientHelpCenterBase type={Bixby.Enums.HelpCenterItemType.Document} />;
};

export default ClientUserGuides;
